import React, { useEffect } from "react";
import ReviewGuidelines from "../../components/ReviewGuidelines";

import { usePageTransition } from "../../services/hooks/usePageTransition";

export default function reviewGuidelines() {
  const { startTransition, completeTransition } = usePageTransition();

  useEffect(() => {
    completeTransition();

    return () => {
      startTransition();
    };
  }, []);

  return <ReviewGuidelines />;
}
